export default __webpack_public_path__ + "static/media/html.1336fa4c.png";